import React from "react";
import { Link } from "react-router-dom";
import GrowniverseLogo from "../Photos/Logo/growniverse-logo-full-bordered.svg";

const RefundPolicy = () => {
  return (
    <section className="refund-section">
      {/* ✅ Embedded CSS */}
      <style>
        {`
          .refund-section {
            background-color: #000;
            color: #ccc;
            padding: 100px 20px 40px;
            position: relative;
            min-height: 100vh;
          }

          .back-button {
            position: fixed;
            top: 20px;
            left: 20px;
            background-color: #00f6ff;
            color: #000;
            font-weight: 600;
            padding: 8px 14px;
            border-radius: 4px;
            text-decoration: none;
            box-shadow: 0 0 10px rgba(0,246,255,0.5);
            transition: background-color 0.3s ease;
            z-index: 1000;
          }

          .back-button:hover {
            background-color: #00c6d6;
          }

          .refund-container {
            max-width: 900px;
            margin: 0 auto;
            position: relative;
            z-index: 2;
          }

          .refund-title {
            color: #00f6ff;
            font-weight: 700;
            margin-bottom: 20px;
            text-align: center;
          }

          .refund-policy h6 {
            color: #fff;
            margin-top: 25px;
            font-size: 16px;
          }

          .refund-policy p, .refund-policy ul {
            line-height: 1.6;
            font-size: 14px;
            color: #ddd;
          }

          .refund-policy ul {
            margin-left: 20px;
          }

          .refund-policy a {
            color: #00f6ff;
            text-decoration: none;
          }

          .refund-footer {
            text-align: center;
            margin-top: 40px;
          }

          .refund-logo {
            width: 180px;
            margin-bottom: 10px;
          }

          .refund-tagline {
            color: #fff;
            font-weight: 600;
            letter-spacing: 1px;
          }

          @media (max-width: 768px) {
            .refund-section {
              padding: 80px 15px 25px;
            }

            .refund-policy p, .refund-policy ul {
              font-size: 13px;
            }

            .refund-logo {
              width: 140px;
            }

            .refund-title {
              font-size: 18px;
            }
          }

          @media (max-width: 480px) {
            .refund-policy p, .refund-policy ul {
              font-size: 12px;
            }

            .refund-title {
              font-size: 16px;
            }

            .refund-logo {
              width: 120px;
            }

            .refund-tagline {
              font-size: 12px;
            }
          }
        `}
      </style>

      {/* ✅ Back Button */}
      <Link to="/" className="back-button">
        ← Back to Home
      </Link>

      <div className="refund-container">
        <h6 className="refund-title">Growniverse Refund Policy</h6>

        <div className="refund-policy">
          <p>
            At Growniverse, we strive to provide the Best Possible Digital Learning Experience for our students. However, we understand that sometimes circumstances may change, and you may need to cancel your enrollment in one of our online digital courses.
          </p>

          <h6>Cancellation Policy</h6>
          <ul style={{ listStyleType: "square" }}>
            <li>If you cancel your enrollment within 24 hours of purchasing an online digital course or package you will receive a refund with 18% deduction.</li>
            <li>To cancel your enrollment, please contact our support team via email at <a href="mailto:admin@growniverse.com">admin@growniverse.com</a> within 24 hours of purchasing the course or package.</li>
            <li>Please include your Growniverse ID, Course or Package Name, and a well-defined reason for cancellation in your email.</li>
            <li>Refunds will be processed within 3-5 business days of receiving your cancellation request.</li>
          </ul>

          <h6>Exceptions</h6>
          <ul style={{ listStyleType: "square" }}>
            <li>Refunds will not be issued for cancellations made after 24 hours of purchasing the course or package.</li>
            <li>Refunds will not be issued for courses or packages that have already been accessed or downloaded.</li>
          </ul>

          <h6>Changes to This Policy</h6>
          <ul style={{ listStyleType: "square" }}>
            <li>Growniverse reserves the right to modify or update this cancellation policy at any time without prior notice.</li>
          </ul>

          <p>If you have any questions or concerns about this policy, please don't hesitate to contact our support team.</p>
        </div>

        <div className="refund-footer">
          <img src={GrowniverseLogo} alt="Growniverse" className="refund-logo" />
          <p className="refund-tagline">
            GROWNIVERSE<br />
            A UNIVERSE WHERE YOU GROW
          </p>
        </div>
      </div>
    </section>
  );
};

export default RefundPolicy;
